import { APPS_MORE_BANNER_DETAIL, AUTO_MOD_LIST, GET_GOOGLE_TRACKING_ID, APPS_MORE_CUSTOM_LANGUAGE, APPS_MORE_FILTERS, APPS_MORE_HASTAG_HIGHLIGHTER, GET_FONTS, GET_COLLABORATORS, ACTIVE_VIDEO_POPUP, GET_CTA_STATUS, GET_CUSTOM_CSS_STATUS, THEME_UPDATE, SNAPUP_DETAILS } from './keys'
const initialState = { detail: null, autoModList: null, fonts: null, collaborators: null, ctaStatus: false, snapUpData:[], photoboothData : {'status' : 0} }
export default function reducer(state = initialState, action) {



    switch (action.type) {
        case APPS_MORE_BANNER_DETAIL: {
            let { details } = state;
            return { ...state, detail: action.payload }
        }
        case GET_FONTS: {
            return { ...state, fonts: action.payload }
        }
        case GET_GOOGLE_TRACKING_ID: {
            return { ...state, googleTracking: action.payload }
        }
        case GET_CTA_STATUS: {
            return { ...state, data: state.detail.wall.Personalization.ctaStatus = action.payload ? 1 : 0 }
        }
        case ACTIVE_VIDEO_POPUP: {
            return { ...state, video_popup: action.payload }
        }
        case GET_CUSTOM_CSS_STATUS: {
            return { ...state, data: state.detail.wall.Personalization.cssStatus = action.payload ? 1 : 0 }
        }
        case THEME_UPDATE: {
            return { ...state, data: state.detail.wall.Personalization.widgetTheme = action.payload }
        }
        // case GET_COLLABORATORS: {
        //     return {...state, collaborators: action.payload}
        // }
        case AUTO_MOD_LIST: {
            return { ...state, autoModList: action.payload }
        }
        case SNAPUP_DETAILS:{ 
            return { ...state, snapUpData: { ...state.snapUpData, ...action.payload} };
        }
        default:
            return { ...state }
    }

}